import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ItemGrupo } from '../../../../dtos/grupos-itens.dto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BudgetService } from '../../../../services/budget.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';

@Component({
  selector: 'app-modal-editar-item-grupo',
  templateUrl: './modal-editar-item-grupo.component.html',
  styleUrl: './modal-editar-item-grupo.component.scss'
})
export class ModalEditarItemGrupoComponent implements OnInit {
  @Input() item: ItemGrupo | null = null;
  @Input() tipoDeCalculo: number = 0;
  @Input() orcamentoId: string = '';

  itemForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private budgetService: BudgetService,
    private toastService: ToastService) { }

  ngOnInit(): void {
    console.log(this.item);

    this.iniciarForm();

    if (this.item) {
      this.itemForm.patchValue({
        id: this.item.id || '',
        orcamentoId: this.orcamentoId || '',
        item: this.item.item || '',
        quantidade: this.item.quantidade || 0,
        quantidadeDeDia: this.item.quantidadeDeDia || 0,
        quantidadeDePessoa: this.item.quantidadePessoa || 0,
        valorUnitario: this.item.valorUnitario || 0,
        tipoDeCalculo: this.tipoDeCalculo,
        sobrepor: this.item.sobrepor ? '1' : '0'
      });
    }
  }

  iniciarForm(): void {
    this.itemForm = this.fb.group({
      id: [''],
      orcamentoId: [''],
      item: [''],
      quantidade: [0],
      quantidadeDeDia: [0],
      quantidadeDePessoa: [0],
      valorUnitario: [0],
      tipoDeCalculo: [0],
      sobrepor: ['0']
    });
  }

  // ref add-documents-modal.component
  atualizarItem(): void {

    if (!this.itemForm.valid) {
      this.toastService.show("Erro ao atualizar Item. Verifique campos obrigatórios.", {
        classname: "bg-danger text-light",
      });
      return;
    }

    this.budgetService.atualizarItemGrupo(this.itemForm.value, true).subscribe({
      next: (response) => {
        this.activeModal.dismiss();
        this.toastService.show("Item atualizado com sucesso", {
          classname: "bg-success text-light",
        });
      },
      error: (error) => {
        this.toastService.show("Ocorreu um erro ao tenta atualizar o Item.", {
          classname: "bg-danger text-light",
        });
      }
    })
    // if (!this.documentoForm.valid) {
    //   this.documentoForm.markAllAsTouched();
    //   return;
    // }

    // const documentoValies = this.documentoForm.value;

    // const novoDocumento: Documento = {
    //   nomeFeira: '',
    //   descricao: documentoValies.descricao,
    //   projetoId: documentoValies.projetoId,
    //   tipoDocumento: parseInt(documentoValies.tipoDocumento)
    // }

    // this.documentoService.adicionarDocumento(novoDocumento);

    // this.activeModal.dismiss();

    // this.toastService.show("Cadastro com sucesso!", {
    //   classname: "bg-success text-light",
    // });

    // //this.documentoForm.reset();
  }
}
